/**
 * Money for operators: always the ISO code, never a bare "$".
 *
 * Orders are settled in the client's wallet currency (HKD, MYR, IDR, CNY, …),
 * so a hard-coded "$" prefix mislabels almost every row. `currencyDisplay:
 * 'code'` renders "HKD 50.00", which is unambiguous when several currencies
 * share one table.
 */
export function formatMoney(amount, currency) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '-';
  const code = String(currency || '').trim().toUpperCase();
  const plain = value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (!code) return plain;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'code',
    }).format(value);
  } catch {
    return `${code} ${plain}`;
  }
}

export default formatMoney;
